import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import { useSuggestedCarouselsBySameCategory } from "@domain/carousel/hooks";
import { ContentLanguage } from "@domain/lms/contentLanguage";
import { Carousel as GraphicCarousel } from "@ui/components/carousel/carousel";
import { CarouselThumbnail } from "./carouselThumbnail";

interface CarouselSuggestionsByCategoryProps extends React.HTMLAttributes<HTMLDivElement> {
	carouselId: string;
	language?: ContentLanguage;
}

export const CarouselSuggestionsByCategory: React.FC<CarouselSuggestionsByCategoryProps> = ({
	carouselId,
	language,
	...htmlProps
}) => {
	const { result: suggestions, loading } = useSuggestedCarouselsBySameCategory(10, carouselId);

	if (loading && !suggestions) return <ClipLoader />;

	return (
		<GraphicCarousel
			{...htmlProps}
			title={I18n.t("carousel.suggestions_same_category")}
			items={suggestions ?? []}
			renderItem={(carousel) => <CarouselThumbnail carousel={carousel} />}
			loading={loading}
			itemWidth={316}
			itemHeight={316}
		/>
	);
};
